import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "C:\\app\\Workspace\\frame-frontend\\src\\app\\[[...slug]]\\client.jsx");
